// Принтер с выезжающим листом — увеличенная версия .printer-mini из макета (экран 8).
// Раньше здесь была гифка на 60vw; вектор чётче на киоск-экране и не тянет лишний ассет.
//
// size="sm" — уменьшенный принтер в нижней карточке экрана печати, когда
// верхнюю карточку занимает реклама. Геометрия та же, в процентах от рамки;
// в абсолютных единицах заданы только скругления и щель — их и масштабируем.
//
// Видимая часть листа ограничена областью под щелью внутри рамки принтера.
// sheetFeed раскрывает только эту область, не высоту всего принтера.
const SIZES = {
    lg: { box: "w-[58vw] h-[28vh]", body: "rounded-[2vh]", slot: "h-[1.4vh] rounded-b-[0.8vh]", feed: "rounded-t-[1.2vh]", sheet: "border-[0.3vh] rounded-b-[1vh]", led: "w-[1.6vh] h-[1.6vh]" },
    sm: { box: "w-[15vh] h-[9vh]", body: "rounded-[0.9vh]", slot: "h-[0.6vh] rounded-b-[0.4vh]", feed: "rounded-t-[0.6vh]", sheet: "border-[0.2vh] rounded-b-[0.5vh]", led: "w-[0.8vh] h-[0.8vh]" },
};

function PrinterAnimation({ size = "lg" }) {
    const s = SIZES[size] || SIZES.lg;
    // Пропорция корпуса ~1.16:1, как в макете. Ширина большого задана в vw, а
    // не в vh: на портретном экране киоска vh-ширина вылезала за края карточки.
    return (
        <div data-testid={`printer-animation-${size}`} className={`relative mx-auto flex-none ${s.box}`}>
            {/* лоток выдачи: лист выезжает из-под корпуса, поэтому он ниже по z */}
            <div className="absolute left-[22%] right-[22%] top-[62%] h-[32%] overflow-hidden z-[1]">
                <div
                    className={`w-full bg-white border-[#E1E4EB] border-t-0 ${s.sheet}`}
                    style={{ animation: "sheetFeed 2.6s ease-in-out infinite" }}
                />
            </div>
            {/* корпус */}
            <div className={`absolute left-0 right-0 top-[22%] h-[40%] bg-[#12161F] z-[3] ${s.body}`} />
            {/* щель выдачи */}
            <div className={`absolute left-[12%] right-[12%] top-[59%] bg-[#080B10] z-[3] ${s.slot}`} />
            {/* подающий лоток сверху */}
            <div className={`absolute left-[22%] right-[22%] top-[6%] h-[16%] bg-[#E1E4EB] z-[2] ${s.feed}`} />
            {/* индикатор работы на корпусе */}
            <div
                className={`absolute left-[8%] top-[32%] rounded-full bg-[#246CE2] z-[4] ${s.led}`}
                style={{ animation: "pulse 1.4s ease-in-out infinite" }}
            />
        </div>
    );
}

export default PrinterAnimation;
